import React, { FC } from 'react';
import LoadingPage from './LoadingPage';
import { ErrorPage } from './ErrorPage';

interface TransitionProps {
  loading: boolean;
  error: {
    message: string;
  };
  headerHeight?: number;
}

export const Transition: FC<TransitionProps> = ({ loading, error, headerHeight }) => {
  if (loading) {
    return <LoadingPage headerHeight={headerHeight} />;
  }

  if (error) {
    return <ErrorPage>{error.message}</ErrorPage>
  }

  return <span/>
}